"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Point.js.map